import { Product } from 'api/LoanOriginationSystem/LoanOriginationSystemProductsApi';
import { LoanOriginationSystemProductApplicationSetupState } from './ApplicationSetup/Types';
import { ApplicationsWorkflowSetupState } from './ApplicationsWorkflowSetup/Types';
import { ApplicationFormConfigurationState } from './ApplicationFormConfiguration/Types';
import { CalculatedVariablesState } from './CalculatedVariables/Types';

export enum ProductConfigurationStep {
  ApplicationFormConfiguration = 'application-form-configuration',
  ApplicationSetup = 'application-setup',
  WorkflowSetup = 'workflow-setup',
  ApplicationAutomation = 'application-automation',
}

export interface LoanOriginationSystemProductConfigurationState {
  applicationSetup: LoanOriginationSystemProductApplicationSetupState;
  applicationWorkflowSetup: ApplicationsWorkflowSetupState;
  applicationFormConfiguration: ApplicationFormConfigurationState;
  calculatedVariables: CalculatedVariablesState;
  product: Product | null;
}
